import {
  AiModelState,
  getPrefixName,
  hideRadioClassName,
  Prefix,
  stores2storeScopes,
} from './share';
import { Radio } from 'antd';
import { useCallback, useMemo } from 'react';
import { updateProvideInvoice } from 'views/BootGuide/service';
import ModalMode from './ModalMode';
import { useTranslate } from '@tolgee/react';
import useSmartField from 'hooks/useSmartField';

type FV = BootGuide.AiModel.FormValues.ProvideInvoice;

export function useLabel() {
  const { t } = useTranslate();

  return useMemo(() => {
    return {
      none: t('本店不提供收据/发票'),
      invoiceAndReceipt: t('本店提供收据/发票'),
      receipt: t('本店不提供发票，仅提供收据'),
      invoice: t('本店不提供收据，仅提供发票'),
    } as const;
  }, [t]);
}

function ProvideInvoice({ prefix, singleMode }: { prefix?: Prefix; singleMode?: boolean }) {
  const label = useLabel();

  const {
    field: { value, onChange },
  } = useSmartField<FV['value']>(getPrefixName('value', prefix));

  const getHideStyle = (type: FV['value']) =>
    singleMode && value !== type ? { display: 'none' } : undefined;

  return (
    <div className="mt-[6px]">
      {Object.keys(label).map((key) => {
        return (
          <div key={key} className="mb-2" style={getHideStyle(key)}>
            <Radio
              className={singleMode ? hideRadioClassName : undefined}
              checked={value === key}
              onChange={({ target: { checked } }) => checked && onChange(key)}
            >
              {label[key]}
            </Radio>
          </div>
        );
      })}
    </div>
  );
}

export function ProvideInvoiceBootGuide(props: AiModelState<FV>) {
  const label = useLabel();

  return (
    <ModalMode
      state={props}
      title={props.t('提供收据/发票')}
      tips={props.t(
        '我还需要了解一些您的「店铺服务」您的店铺是否提供收据/发票?以下是一些常见的选项供您选择和调整',
      )}
      form={<ProvideInvoice />}
      getFirstInitialValues={useCallback(({ stores }): { values: FV[] } => {
        return {
          values: [
            { value: 'receipt', storeScopes: stores2storeScopes(stores) },
            { value: 'invoice', storeScopes: [] },
            { value: 'invoiceAndReceipt', storeScopes: [] },
            { value: 'none', storeScopes: [] },
          ],
        };
      }, [])}
      updateApi={updateProvideInvoice}
      getFirstFormItem={({ value }, _, storeSelect) => {
        return (
          <div>
            <section>
              {label[value]}
              {storeSelect}
            </section>
          </div>
        );
      }}
      getFirstFormStoreSelectKey={({ value }) => value}
    />
  );
}

export default ProvideInvoice;
